import React, { useState, useEffect, Fragment } from 'react';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'reactstrap';
import { gAPI_Groups_Plugin } from '../../../../../../constants/APIs';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';

const CodeSnippet = ({
  propertyId,
  integrationId,
  serviceProvider,
  allProperties,
}) => {
  const handleDownload = (isClassic) => {
    const endpoint = `${gAPI_Groups_Plugin}?gid=${getGroupID()}&pid=${propertyId}&iid=${integrationId}&isClassic=${isClassic}`;
    const result = allProperties.filter((elem) => elem.id === propertyId);
    AxiosAPI({
      method: 'get',
      url: endpoint,
    })
      .then((res) => {
        const data = res.data;
        if (data.status) {
          const xmlContent = data.status;
          const blob = new Blob([xmlContent], { type: 'application/xml' });
          const downloadLink = document.createElement('a');

          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = `manifest${isClassic ? '_classic' : ''}${
            result != null && result.length > 0 ? '_' + result[0].name : ''
          }.xml`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        } else {
          console.error('Invalid response: Missing status field');
        }
      })
      .catch((error) => {
        console.error('Download failed:', error);
      });
  };

  return (
    <Fragment>
      <Colxx md="12" className="my-2">
        You can add one or both files via M365 Admin Center (preferred), or
        directly to your Outlook.
      </Colxx>
      <Colxx md="12" className="mb-2">
        For Outlook for Windows (new versions) and Outlook for Web.
      </Colxx>
      <Colxx md="12" className="mb-2">
        <Button
          color="primary"
          size="xs"
          outline
          onClick={() => handleDownload(false)}
        >
          <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon> Download
          manifest.xml
        </Button>
      </Colxx>
      <Colxx md="12" className="my-2">
        For Outlook for Windows (earlier versions) and Outlook for Mac .
      </Colxx>
      <Colxx md="12" className="mb-3">
        <Button
          color="primary"
          size="xs"
          outline
          onClick={() => handleDownload(true)}
        >
          <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon> Download
          manifest.xml
        </Button>
      </Colxx>
    </Fragment>
  );
};

export default CodeSnippet;
